import { Card } from "@ui/Card";
import { ChipList } from "@ui/ChipList";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import type { DiscoveryCategory } from "@/client";
import { categoryHref } from "../utils/categoryHref";

type Props = {
	category: DiscoveryCategory;
};

export const CategoryCard = (props: Props) => {
	const items = () =>
		(props.category.creators ?? []).slice(0, 3).map((creator) => ({
			alt: creator.display_name || creator.handle || "Creator",
			src: creator.avatar ?? undefined,
		}));

	const extra = () => {
		const total = props.category.count ?? props.category.creators?.length ?? 0;
		return Math.max(0, total - items().length);
	};

	return (
		<Card as="a" href={categoryHref(props.category.id)}>
			<VStack spacing="intermediate">
				<MaterialSymbol
					container={{
						size: "2rem",
						borderRadius: "0.5rem",
						background: "rgba(69, 185, 180, 0.12)",
					}}
					symbol={props.category.icon}
					color="primary"
				/>
				<Text as="span" size="intermediate" weight="semi-bold" color="ink">
					{props.category.name}
				</Text>
				<div class="askgvt-category-faces">
					<ChipList items={items()} size="small" />
					<Show when={extra() > 0}>
						<Text family="mono" size="xsmall" color="fg3">
							+{extra()}
						</Text>
					</Show>
				</div>
			</VStack>
		</Card>
	);
};
